
import { GenericTabsMenuItemType } from "components/tabs"
import { useParams } from "react-router-dom"
import { EcoRoute } from "types"
import { useMapParamsToUrlPattern } from "./useMapParamsToUrlPattern"

export const useMapRouteChildrenToTabsMenuItem = () => {
    const params = useParams()
    const mapParamsToUrl = useMapParamsToUrlPattern()

    return (routes?: EcoRoute[], baseUrl?: string): GenericTabsMenuItemType[] | undefined => {
        return routes?.map<GenericTabsMenuItemType>((route) => {
            return {
                path: `/${mapParamsToUrl(baseUrl!, params as any)}/${route.path}` || '',
                label: route.config.label
            }
        })
    }
}